import React from "react";
import { Text, View } from "react-native";
import { FormLabel } from "./FormLabel";

type Props = {
  label?: string;
  error?: string;
  className?: string;
  children: React.ReactElement<{ error?: string }>;
};

export const FormField: React.FC<Props> = ({
  label,
  error,
  className = "",
  children,
}) => {
  return (
    <View className={`mb-4 ${className}`}>
      {label && <FormLabel>{label}</FormLabel>}
      {React.cloneElement(children, { error })}
      {error && (
        <Text
          className="text-xs text-red-500 mt-1 ml-1"
          accessibilityRole="alert"
        >
          {error}
        </Text>
      )}
    </View>
  );
};

export default FormField;
